/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// @mui icons

// Soft UI Dashboard React components

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Overview page components
import Header from "layouts/profile/components/Header";

import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard React examples
// import WorkWithTheRockets from "layouts/dashboard/components/WorkWithTheRockets";
// import Projects from "layouts/dashboard/components/Projects";
import ProfileInfo from "examples/Cards/InfoCards/ProfileInfoCard";
import {Auth} from 'aws-amplify'
import {useEffect, useState} from "react"
import SuiButton from "components/SuiButton";
function Overview() {
  const [name,setname]=useState("")
  const [accStatus, setAccStatus] = useState("")
  const [email,setemail]=useState()
  
  const [num,setnum]=useState()

  useEffect(()=>{

    Auth.currentUserInfo().then(value=>{
      if(value.username == "admin"){
      setname(value.username)
      Auth.currentAuthenticatedUser().then(val=>{
        setemail(val.attributes.email)
        setnum(val.attributes['phone_number'])
        setAccStatus(val.attributes['custom:accStatus'])
      })
      }
      else{

        if(value.attributes["custom:company"] != undefined) {
          Auth.currentAuthenticatedUser().then(val=>{
            setname(val.attributes['custom:company'])
            setemail(val.attributes.email)
            setnum(val.attributes['phone_number'])
            setAccStatus(val.attributes['custom:accStatus'])
          })
        }
        else {
          Auth.currentAuthenticatedUser().then(val=>{
            setname(val.attributes['custom:fullname'])
            setemail(val.attributes.email)
            setnum(val.attributes['phone_number'])
            setAccStatus(val.attributes['custom:accStatus'])
          })
        }
      
      }
    })
  },[])
  return (
    <DashboardLayout>
      <Header />
      <SuiBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <ProfileInfo
              title="profile information"
              info={{
                fullName: name,
                mobile: num,
                email: email,
                location: "Malaysia",
              }}
              status= {accStatus}
            />
          </Grid>
        </Grid>
      </SuiBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Overview;
